var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "temp"
  }, [_c('v-container', [_c('v-card', {
    staticClass: "py-40px",
    attrs: {
      "flat": "",
      "color": "rgba(255,255,255,0.8)"
    }
  }, [_c('v-container', [_c('h1', [_vm._v("홈페이지 리뉴얼 안내")]), _c('p', [_vm._v(" 홈페이지가 새롭게 리뉴얼 작업 중에 있습니다. "), _c('br'), _vm._v(" 보다 편리하게 이용하실 수 있도록 최선의 노력을 다하겠습니다. "), _c('br'), _vm._v(" 고객님들의 많은 양해 부탁드립니다. ")]), _c('v-img', {
    attrs: {
      "src": "/images/main/renewal-image.png",
      "alt": ""
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }